import AdFoxHelper from '@/js/desktop/helpers/AdFoxHelper';
import PromoPlacementManager from '@/js/desktop/services/PromoPlacementManager';

let isInitialized = false;

export const initPromoPlacement = () => {
    if (isInitialized) {
        return;
    }

    try {
        if (!window.appConfig || !window.appConfig.promoPlacements) {
            return;
        }

        if (!window.appConfig.promoPlacementsOwnerId) {
            console.error('[PromoPlacementsInit] ownerId not provided');
            return;
        }

        AdFoxHelper.getInstance();

        window.yaContextCb = window.yaContextCb || [];

        window.yaContextCb.push(() => {
            if (isInitialized) {
                return;
            }

            try {
                if (!window.appConfig?.promoPlacements || !window.appConfig?.promoPlacementsOwnerId) {
                    console.error('[PromoPlacementsInit] Missing config in callback');
                    return;
                }

                if (!PromoPlacementManager || typeof PromoPlacementManager.getInstance !== 'function') {
                    console.error('[PromoPlacementsInit] PromoPlacementManager not available');
                    return;
                }

                const manager = PromoPlacementManager.getInstance();
                if (!manager) {
                    console.error('[PromoPlacementsInit] Manager is null');
                    return;
                }

                manager.init(window.appConfig.promoPlacements, window.appConfig.promoPlacementsOwnerId);
                window.promoPlacementManager = manager;

                isInitialized = true;
            } catch (error) {
                console.error('[PromoPlacementsInit] Error in callback:', error);
            }
        });

    } catch (error) {
        console.error('[PromoPlacementsInit] Init failed:', error);
    }
};

export function notifyPromoPlacementSearchStart(tourCriteria) {
    if (!tourCriteria) return;

    if (window.promoPlacementManager && typeof window.promoPlacementManager.onSearchStart === 'function') {
        try {
            window.promoPlacementManager.onSearchStart(tourCriteria);
        } catch (error) {
            console.error('[SearchController] Error handling promo placements in goSearch:', error);
        }
    } else {
        const deferredCriteria = tourCriteria;
        window.yaContextCb = window.yaContextCb || [];
        window.yaContextCb.push(() => {
            const mgr = window.promoPlacementManager;
            if (!mgr) return;
            try {
                mgr.onSearchStart(deferredCriteria);
            } catch (error) {
                console.error('[SearchController] Error handling promo placements in deferred goSearch:', error);
            }
        });
    }
}
